import { createAction, PayloadAction } from '@reduxjs/toolkit';
import { put, select, takeLatest } from 'redux-saga/effects';

import { fetchGlobalDiseaseRisks } from 'diseaseActivitiesGlobal/diseaseActivitiesGlobal.saga';
import {
  fetchDiseaseActivityDetails,
  fetchDiseaseActivityList,
} from 'diseaseActivitiesInCountryLocations/diseaseActivitiesInCountryLocations.saga';
import {
  fetchTopDescriptionForCountry,
  fetchTopDescriptionForUserLocation,
} from 'diseaseActivitiesInCountryLocations/diseaseActivityUpdates.saga';
import { fetchDiseaseRisks } from 'diseaseActivitiesInLocation/diseaseActivitiesInLocation.saga';
import { DiseaseActivityPanelState } from 'diseaseActivityPanels/disacPanelUtils';
import diseaseActivityPanelsSelectors from 'diseaseActivityPanels/diseaseActivityPanels.selectors';

import diseaseActivitiesTimeFrameSelectors from './diseaseActivitiesTimeFrame.selectors';
import { changeStartDate } from './diseaseActivitiesTimeFrame.slice';

export const setStartDate = createAction<string>('diseaseActivitiesTimeFrame/setStartDate');

function updateTimeframeSaga() {
  return function* (action: PayloadAction<string>) {
    const isGlobalSelected: boolean = yield select(diseaseActivityPanelsSelectors.isGlobalSelected);
    const { isVisibleDLP, isVisibleDELP, isVisibleEDP }: DiseaseActivityPanelState = yield select(
      diseaseActivityPanelsSelectors.getPanelState
    );
    const currentStartDate: string = yield select(diseaseActivitiesTimeFrameSelectors.getStartDate);
    const isTimeFrameChanged = action.payload !== currentStartDate;

    if (isTimeFrameChanged) {
      yield put(changeStartDate(action.payload));
      if (isVisibleDLP) {
        if (isGlobalSelected) {
          yield put(fetchGlobalDiseaseRisks());
        } else {
          yield put(fetchDiseaseRisks());
        }
      }
      if (isVisibleDELP) {
        yield put(fetchDiseaseActivityList());
        yield put(fetchTopDescriptionForUserLocation());
      }
      if (isVisibleEDP) {
        yield put(fetchDiseaseActivityDetails());
        yield put(fetchTopDescriptionForCountry());
      }
    }
  };
}

function* diseaseActivitiesTimeFrameSaga() {
  yield takeLatest(setStartDate, updateTimeframeSaga());
}

export default diseaseActivitiesTimeFrameSaga;
